// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1axgr","content":"styles_content__ZdEyc","row":"styles_row__3IyOc","footer":"styles_footer__2-B5L","phraseLength":"styles_phraseLength__3afQM"};